<template>
    <div>
      <common-list
        ref="list"
        url="SalesPart/GetList"
        @currentrow="handlerCurrentRow"
      >
        <!-- 条件区域 -->
        <template v-slot:filter="{ filter }">
          <el-col :span="6">
          <el-form-item label="配件名称" prop="PartName">
            <el-input
              v-model.trim="filter.PartName"
              placeholder="配件名称" 
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        </template>
        <!-- 按钮区域 -->
        <template v-slot:option>
          
        </template>
        <!-- 展示区域 -->
        <template v-slot:body>
          <el-table-column
            label="销售单号"
            prop="SalesOrderId"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="配件名称"
            prop="PartName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="Quantity"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="单位" 
            prop="Unit" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="库存单号" 
            prop="InventoryId" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="来源" 
            prop="Source" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="售价" 
            prop="Price" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作人" 
            prop="Operator" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="销售时间" 
            prop="SalesTime" 
            show-overflow-tooltip>
          </el-table-column>
        </template>
      </common-list>
      <!-- 弹窗区域 Show -->
      
    </div>
  </template>
  
  <script>

  export default {
    components: {
        
    },
    data() {
      return {
        itemAddEdit: {},
        itemShow:{},
        showitem: [],
        OutList: {},
      };
    },
    computed: {

    },
    mounted() {
     
    },
    methods: {
      getData() {
        this.$refs.list.getTableData();
      },
      add() {
        this.itemAddEdit = {};
      },
      edit() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemAddEdit = { KeyId: this.currentrow.KeyId };
      },
      outbound(){
        
      this.OutList = {  };
      },
      deleteItem() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.$confirm(
          `将删除配件名称为【${this.currentrow.PartName}】的配件称重信息, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            this.$delete("WeighingPart/Delete", {
              KeyId: this.currentrow.KeyId,
            }).then(() => {
              this.$message.success("删除成功");
              this.$refs.list.getTableData();
            });
          })
          .catch(() => {});
      },
      show() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemShow = { SalesId: this.currentrow.SalesId };
       
      },
    },
  };
  </script>
  
  <style>
  </style>